import React from "react";
import { useTranslation } from 'react-i18next';
import styled from "styled-components";
import { Card, CardHeader, CardTitle, CardDescription } from '../components/ui/Card';
import { theme } from '../styles/theme';

const PageContainer = styled.div`
  min-height: 80vh;
  padding: ${theme.spacing['4xl']} ${theme.spacing.xl};
  background: ${theme.gradients.hero};
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: ${theme.spacing['4xl']};
`;

const PageTitle = styled.h1`
  font-size: ${theme.typography.fontSize['4xl']};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.secondary[900]};
  margin-bottom: ${theme.spacing.lg};
`;

const PageSubtitle = styled.p`
  font-size: ${theme.typography.fontSize.xl};
  color: ${theme.colors.secondary[600]};
  max-width: 600px;
  margin: 0 auto;
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: ${theme.spacing['2xl']};
  margin-bottom: ${theme.spacing['4xl']};
`;

const ServiceCard = styled(Card)`
  text-align: left;
  
  h3 {
    color: ${theme.colors.primary[700]};
    margin-bottom: ${theme.spacing.md};
  }
  
  ul {
    list-style: none;
    padding: 0;
    margin-top: ${theme.spacing.lg};
    
    li {
      padding: ${theme.spacing.sm} 0;
      color: ${theme.colors.secondary[600]};
      position: relative;
      padding-left: ${theme.spacing.lg};
      
      &::before {
        content: '✓';
        position: absolute;
        left: 0;
        color: ${theme.colors.primary[600]};
        font-weight: bold;
      }
    }
  }
`;

function Servicios() {
  const { t } = useTranslation(['pages', 'common']);

  return (
    <PageContainer>
      <Container>
        <PageHeader>
          <PageTitle>{t('pages:services.title')}</PageTitle>
          <PageSubtitle>{t('pages:services.subtitle')}</PageSubtitle>
        </PageHeader>

        <ServicesGrid>
          <ServiceCard>
            <CardHeader>
              <CardTitle>{t('pages:services.details.software.title')}</CardTitle>
              <CardDescription>
                {t('pages:services.details.software.description')}
              </CardDescription>
            </CardHeader>
            <ul>
              {t('pages:services.details.software.benefits', { returnObjects: true }).map((benefit, index) => (
                <li key={index}>{benefit}</li>
              ))}
            </ul>
          </ServiceCard>

          <ServiceCard>
            <CardHeader>
              <CardTitle>{t('pages:services.details.ai.title')}</CardTitle>
              <CardDescription>
                {t('pages:services.details.ai.description')}
              </CardDescription>
            </CardHeader>
            <ul>
              {t('pages:services.details.ai.benefits', { returnObjects: true }).map((benefit, index) => (
                <li key={index}>{benefit}</li>
              ))}
            </ul>
          </ServiceCard>

          <ServiceCard>
            <CardHeader>
              <CardTitle>{t('pages:services.details.consulting.title')}</CardTitle>
              <CardDescription>
                {t('pages:services.details.consulting.description')}
              </CardDescription>
            </CardHeader>
            <ul>
              {t('pages:services.details.consulting.benefits', { returnObjects: true }).map((benefit, index) => (
                <li key={index}>{benefit}</li>
              ))}
            </ul>
          </ServiceCard>
        </ServicesGrid>
      </Container>
    </PageContainer>
  );
}

export default Servicios;